define('modules/alternative',['require','exports','module','modules/media/binder'],function(require, exports, module) {
	"use strict";

	var Binder = require("modules/media/binder");

	var Alternative = {

		events : {
			//"click label": "addFilter",
			//"click input:checkbox": "addFilter"
		},
		makeActive : function() {

			//this.$el.addClass("active");
		},

		clicked : function(event) {
			var el = event.currentTarget;
			var assigned = 0;
			if (el.parentNode.style.bottom === "0px") {
				assigned = el.getAttribute("data-move") + 'px';
			}
			el.parentNode.style.bottom = assigned;

		},

		changePic : function(event) {
			var el = event.currentTarget;

			//	this.clicked({currentTarget: el.parentNode.querySelectorAll('.h-nav')[0] });

			var bar = el.parentNode.querySelectorAll('.h-nav')[0];
			el.parentNode.style.bottom = bar.getAttribute("data-move") + 'px';

			//////console.log (el)
			var items = document.querySelectorAll('.alt-gal div.is-boxed');

			for (var i = 0; i < items.length; i++) {

				//////console.log (item[i])

				if (items[i].getAttribute("data-rel") === el.rel) {
					items[i].style.zIndex = 1000;

				} else {

					items[i].style.zIndex = 0;
				}

			}

		},

		release : function(elm) {

			////console.log ('releaseed')

			Binder.removeEvent(this.nav, "click", this.clicked);

			for (var i = 0; i < this.toclick.length; i++) {

				Binder.removeEvent(this.toclick[i], "click", this.changePic);

			}

			this.nav = {};
			this.toclick = {};
			this.contents = {};

		},

		load : function(elm) {

			//	console.log ('--> DO')

			this.nav = elm.querySelectorAll('.h-nav')[0];
			this.toclick = elm.querySelectorAll('a');
			this.contents = elm.querySelectorAll('div.is-boxed');
			this.nav.setAttribute('data-move', this.toclick.length * -40);
			this.nav.parentNode.style.bottom = this.toclick.length * -40 + 'px';

			Binder.addEvent(this.nav, "click", this.clicked);

			for (var i = 0; i < this.toclick.length; i++) {

				this.toclick[i].setAttribute('id', 'ck_' + i + elm.getAttribute('id'));
				Binder.addEvent(this.toclick[i], "click", this.changePic);
				////console.log ('-->',   this.toclick[i])

			}

			var items = document.querySelectorAll('.alt-gal div.is-boxed');

			for (var j = 0; j < items.length; j++) {

				items[j].style.zIndex = 0;

			}
			items[0].style.zIndex = 0;

		}
	};

	module.exports = Alternative;
});

